// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__usYmz","sendOtp":"AuthorizeToLogin_sendOtp__2WVmE"};